"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _quizz = require("./contexts/quizz");

var _bool = _interopRequireDefault(require("./forms/bool"));

var _multi = _interopRequireDefault(require("./forms/multi"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SwitcherForm = function SwitcherForm(_ref) {
  var question = _ref.question,
      result = _ref.result;

  if (question && question.choices && question.choices.length) {
    return question.type === "bool" ? _react["default"].createElement(_bool["default"], {
      question: question,
      result: result
    }) : // question.choices.map(c => <InputMulti choice={c} key={c.id} />)
    _react["default"].createElement(_multi["default"], {
      question: question,
      result: result
    });
  } else {
    return _react["default"].createElement("p", null, "loading...");
  }
};

var Quizz = function Quizz() {
  var _useContext = (0, _react.useContext)(_quizz.QuizzContext),
      _useContext2 = _slicedToArray(_useContext, 3),
      state = _useContext2[0],
      dispatch = _useContext2[1],
      api = _useContext2[2];

  var _useContext3 = (0, _react.useContext)(_quizz.ConfigContext),
      _useContext4 = _slicedToArray(_useContext3, 1),
      config = _useContext4[0];

  var questions = config.questionnaire.questions;
  var _state$currentQuestio = state.currentQuestion,
      id = _state$currentQuestio.id,
      label = _state$currentQuestio.label,
      choices = _state$currentQuestio.choices; // console.log("state quizz", state)

  var _goto = function _goto2() {
    // Est-ce une bonne idée ???
    var next = api.getNext();

    if (next && next.id) {
      dispatch({
        type: "SET_CURRENT_QUESTION",
        value: next
      });
    } else {
      console.log("erreur, pas de next");
    }
  };

  var _config$parties$filte = config.parties.filter(function (partie) {
    return partie.questions.indexOf(id) !== -1;
  }),
      _config$parties$filte2 = _slicedToArray(_config$parties$filte, 1),
      current_partie = _config$parties$filte2[0];

  var get_latest_id = function get_latest_id() {
    var latest_quest_id = questions[questions.length - 1].id;
    return latest_quest_id;
  };

  var is_latest = function is_latest() {
    return id === get_latest_id();
  };

  var next_is_disabled = function next_is_disabled() {
    if (!state.currentResult) {
      return true;
    }

    if (state.currentQuestion) {
      if (state.currentQuestion.type === "bool") {
        return !state.currentResult.response_id;
      }

      if (state.currentQuestion.type === "multi") {
        return !(state.currentResult.response_id && state.currentResult.response_id.length);
      }
    } else {
      return true;
    }
  };

  var complete_quizz = function complete_quizz() {
    dispatch({
      type: "COMPLETE_QUIZZ"
    });
  };

  if (id) {
    return _react["default"].createElement("section", null, _react["default"].createElement("h3", null, current_partie && current_partie.label), _react["default"].createElement("h4", null, id, " : ", label), _react["default"].createElement("div", {
      className: "choices"
    }, choices && choices.length && _react["default"].createElement(SwitcherForm, {
      question: state.currentQuestion && state.currentQuestion,
      result: state.currentResult && state.currentResult
    })), _react["default"].createElement("p", {
      className: "buttons"
    }, !is_latest() ? _react["default"].createElement("button", {
      onClick: _goto,
      disabled: next_is_disabled()
    }, "Question suivante") : _react["default"].createElement("button", {
      onClick: complete_quizz,
      disabled: next_is_disabled()
    }, "Voir vos recommandations")));
  } else {
    if (!state.started && config.questionnaire && config.questionnaire.questions.length) {
      return _react["default"].createElement("section", null, _react["default"].createElement("div", {
        className: "description",
        dangerouslySetInnerHTML: {
          __html: config.questionnaire.description
        }
      }), _react["default"].createElement("p", {
        className: "buttons"
      }, _react["default"].createElement("button", {
        onClick: function onClick() {
          return dispatch({
            type: "START_QUIZZ",
            value: {
              questionnaireId: config.questionnaire.id,
              question: config.questionnaire.questions[0]
            }
          });
        }
      }, "Commencer le questionnaire")));
    } else {
      return _react["default"].createElement("p", null, "Recherche");
    }
  }
};

var _default = Quizz;
exports["default"] = _default;